import React from "react";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import UploadButton from "../UploadButton";
import InputBox from "../InputBox";
import HtmlSelect from "../HtmlSelect";
import SubmitButton from "../SubmitButton";
import { urlDepthConstant, selectTypes, Frequency } from "../../Constants";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./AtomizerForm.module.css";
import { components } from "react-select";
import getchCsv from "../../Images/gtech_CSv.jpeg";
import QA from "../../Images/CSV_sample.png";
import Loader from "../../Images/progress.gif";
import {
  getFrequencyList,
  handleExpertInput,
  handleResetSeeker,
  handleSeekerInput,
} from "../../Action/actions";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Bloomfire,
  QAPostForm,
  getBloomFireData,
  handleMultipleFiles,
  listOfPdfUrl,
  pdfUrlData,
  postBlommfireCaegory,
  postPdfAtomizer,
  postScrapUrl,
} from "../../API/api";
import { Actions } from "../../Action";
import AtomizerModal from "../Modals/AtomizerModal/AtomizerModal";
import { fetchUsers_CM_Atomizer } from "../../API/api";
import { store } from "../../Store/store";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import VizParagraph from "../VizParagraph/VizParagraph";
import VizHeader from "../VizHeader/VizHeader";
import MultiSelect from "../MultiSelect/MultiSelect";
import ReusableMultiSelect from "../../NewComponent/ReusableMultiSelect";
import { filterDomainsForComponent } from "../../utils";
import { Input, } from "antd";
import { Select } from 'antd'


const containerStyles = {
  borderColor: '#E0E2E6',
  boxShadow: '0px 1px 2px 0px #1018280D',
  color: '#5C667B !important',
  zIndex: '0',
  width: "100%"
}

const filterDomainsForComponentData = (cmTopics) => {
  return Object.entries(cmTopics).map(([indexId, topic]) => ({
    indexId,
    name: topic,
    label: topic,
    value: topic,
  }));
};

const container = {
  width: "74%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "7%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",
};

const textStylesHeader = {
  fontSize: "22px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  // marginRight: "5px"

};
const JobSection = ({ JobId, handleChangeText }) => {

  return (
      <div className={styles.subContainer}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Job ID<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span></span>
              {/* <VizParagraph type={5}> Job ID*</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div className={styles.formInputs} style={{ width: "100%" }}>
              <InputBox JobId={JobId} handleChangeText={handleChangeText} />
            </div>
          </Grid>
        </Grid>
      </div>
  );
};
const domainSection = (val, onchan, userState) => {

  const onChangeDomain = (data) => {

    const val = filterDomainsForComponent(userState.expertTopics).filter((item) => {
      return data.includes(item.name)
    })

    onchan(val)
  }
  // console.log("filter",filterDomainsForComponent(userState.expertTopics))
  return (
    <div className={styles.subContainer} style={{ marginTop: '10px' }}>
      <Grid container spacing={2} style={{ display: "flex", alignItems: "-moz-initial" }}>
        <Grid item xs={3}>
          <div className={styles.formLabels}>
            <span style={textStyles}>Domains<span></span></span>
            {/* <VizParagraph type={5}> Domains</VizParagraph>&nbsp;: */}
          </div>
        </Grid>
        <Grid item xs={7}>
          <div className={styles.formInputs} style={{ width: "100%", }}>
            {/* <MultiSelect onChangeFunc={onChangeDomain} value={val} isMulti={true} /> */}
            {/* <Select
              size="medium"
              mode="multiple"
              allowClear={true}
              getPopupContainer={() => document.body}
              options={filterDomainsForComponent(userState.expertTopics)}
              style={{ width: "50%", fontSize: '16px' }}
              value={val||[]}
              onChange={onChangeDomain}
               placeholder="Select Domain"
              optionLabelProp="label"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              dropdownStyle={{
                // zIndex: zindexValue ? 1100 : 0,
                textAlign: "left"
              }}
              maxTagCount={0}
              maxTagPlaceholder={`${val?.length || 0} selected`}
            /> */}
            <ReusableMultiSelect
              value={val}
              onChange={onChangeDomain}
              options={filterDomainsForComponent(userState.expertTopics)}
              placeholder="Select Domains"
              maxTagPlaceholder={`${val?.length || 0} selected`}
              allowClear={true}
              disabled={false}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
const PdfLinkUrl = ({ state, handleChangeText, handleChangeName }) => {
  return (
    <>
      <div className={styles.pdfUrl} style={{ marginTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              {/* <VizParagraph type={5}>URL*</VizParagraph>&nbsp;: */}
              <span style={textStyles}>Url<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span></span>
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{ display: "flex", justifyContent: "left", width: "100%", marginBottom: "10px" }}
            >
              <Input
                // placeholder="Write additional details..."
                value={state?.UrlValue}
                // value={renderInputValue()
                style={containerStyles}
                disabled={state?.loading ? true : false}
                onChange={handleChangeName}
              />
              {/* <input
                sx={{ border: 1 }}
                className={styles.textInput}
                onChange={handleChangeName}
                width="100%"
                value={state?.UrlValue}
                disabled={state?.loading ? true : false}
              /> */}
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={styles.pdfUrl} style={{ marginBottom: "15px" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Job ID<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span></span>
              {/* <VizParagraph type={5}>Job ID*</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{ display: "flex", justifyContent: "left", width: "100%" }}
            >
              <Input
                // placeholder="Write additional details..."
                value={state?.jobId}
                // value={renderInputValue()
                style={containerStyles}
                disabled={state?.loading ? true : false}
                onChange={handleChangeText}
              />
              {/* <input
                sx={{ border: 1 }}
                className={styles.textInput}
                onChange={handleChangeText}
                width="100%"
                value={state?.jobId}
                disabled={state?.loading ? true : false}
              /> */}
            </div>
          </Grid>{" "}
        </Grid>
      </div>
    </>
  );
};

const TapImageFile = ({
  handleImage,
  imageProp,
  open,
  setOpen,
  width,
  height,
}) => {
  const state = useSelector((state) => state?.atomizer);
  return (
    <Grid item xs={12} md={2}>
      <img
        src={imageProp}
        alt="sample"
        onClick={handleImage}
        style={{
          cursor: "pointer",
          width: state?.sourceType === "Q&A List (CSV)" ? "100px" : "70px",
          height: "auto",
          objectFit: "contain",
          imageRendering: "auto",
          borderWidth:
            state?.sourceType === "List of Bloomfire Links (CSV)" ? "1px" : "0px",
          borderStyle: "solid",
          borderColor: "#ccc",
          marginRight: "10px",
        }}
      />
      {open ? (
        <IframModel
          open={open}
          setOpen={setOpen}
          image={imageProp}
          width={width}
          height={height}
        />
      ) : (
        ""
      )}
    </Grid>
  );
};

const ScrapUrl = ({
  handleChangeName,
  state,
  handleChangeLink,
  handleImageCheck,
  handlePdfCheck,
  handleChangeUrlDepth,
  handleChangeFrequencyValue,
}) => {
  useEffect(() => {
    getFrequencyList();
  }, []);

  return (
    <>
      <div className={styles.scrapUrlContainer} style={{ marginTop: "9px" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Name<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span></span>
              {/* <VizParagraph type={5}>Name</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{
                display: "flex",
                justifyContent: "left",
                color: "#3e454c;",
                width: "100%",
              }}
            >
              <Input
                placeholder="Enter the Name..."
                style={containerStyles}
                type="url"
                value={state?.Name}
                // value={renderInputValue()}
                disabled={state?.loading ? true : false}
                onChange={handleChangeName}
              />
              {/* <input
                sx={{ border: 1 }}
                className={styles.textInput}
                onChange={handleChangeName}
                width="100%"
                type="url"
                value={state?.Name}
                disabled={state?.loading ? true : false}
              /> */}
            </div>
          </Grid>
        </Grid>
      </div>

      <div className={styles.scrapUrlContainer} style={{ marginTop: "8px", marginBottom: "8px" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Link<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span><span></span></span>
              {/* <VizParagraph type={5}>Link</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{ display: "flex", justifyContent: "left", width: "100%" }}
            >
              <Input
                placeholder="Enter the Link..."
                style={containerStyles}
                type="url"
                value={state?.Link}
                // value={renderInputValue()}
                disabled={state?.loading ? true : false}
                onChange={handleChangeLink}
              />
              {/* <input
                sx={{ border: 1 }}
                className={styles.textInput}
                onChange={handleChangeLink}
                width="100%"
                type="url"
                value={state?.Link}
                disabled={state?.loading ? true : false}
              /> */}
            </div>
          </Grid>
        </Grid>
      </div>

      <div
        className={styles.scrapUrlContainer}
        style={{ marginBottom: "10px" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>URL Depth<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span><span></span></span>
              {/* <VizParagraph type={5}>URL Depth</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{
                display: "flex",

                width: "100%",
              }}
            >
              <div>
                {/* <select
                    className={styles.select}
                    value={state?.UrlDepth}
                    onChange={handleChangeUrlDepth}
                    fontSize="16px"
                    disabled={state?.loading ? true : false}
                  >
                    <option>Select Depth </option>
                    {urlDepthConstant?.map((item, index) => {
                      return <option key={item.key + index}>{item.value}</option>;
                    })}
                  </select> */}
                <Select
                  style={{ width: 160 }}
                  placeholder="Select Depth"
                  onChange={handleChangeUrlDepth}
                  value={typeof state?.UrlDepth === "number" ? state.UrlDepth : undefined}
                  options={urlDepthConstant.map((item) => ({
                    label: item.value,
                    value: item.key,
                  }))}
                  allowClear
                />
              </div>
              <div
                style={{
                  float: "left",
                  display: "flex",
                  alignItems: "baseline",
                  marginLeft: "10px",
                }}
              >
                <span>
                  <span style={textStyles}>Include PDF</span>
                  {/* <VizParagraph type={5}>Include PDF</VizParagraph> */}
                  <FormControlLabel
                    labelPlacement="start"
                    style={{ fontSize: "14px", margin: "0%" }}
                    control={
                      <Checkbox
                        onChange={handlePdfCheck}
                        checked={state?.isIncludePdfChecked}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<RadioButtonCheckedIcon />}
                        size="4px"
                        disabled={state?.loading ? true : false}
                      />
                    }
                  />
                </span>
                <span>
                  <span style={textStyles}>Include Image</span>

                  {/* <VizParagraph type={5}>Include Image</VizParagraph> */}

                  <FormControlLabel
                    labelPlacement="start"
                    style={{ fontSize: "14px", margin: "0%" }}
                    control={
                      <Checkbox
                        onChange={handleImageCheck}
                        checked={state.isIncludeImageChecked}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<RadioButtonCheckedIcon />}
                        size="4px"
                        disabled={state?.loading ? true : false}
                      />
                    }
                  />
                </span>
              </div>
            </div>
          </Grid>{" "}
        </Grid>
      </div>

      <div
        className={styles.scrapUrlContainer}
        style={{ marginBottom: "18px" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Update Frequency<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span><span></span></span>

              {/* <VizParagraph type={5}>Update Frequency</VizParagraph> */}
          
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{ display: "flex", justifyContent: "left" }}
            >
              {/* <select
                className={styles.select}
                value={state.Frequency}
                onChange={handleChangeFrequencyValue}
                fontSize="16px"
                disabled={state?.loading ? true : false}
              >
                <option>Select Frequency</option>
                {Frequency.map((item, index) => {
                  return <option key={item.key + index}>{item.value}</option>;
                })}
              </select> */}
              <Select
                style={{ width: 160 }}
                placeholder="Select Frequency"
                onChange={handleChangeFrequencyValue}
                value={typeof state.Frequency === "number" ? state.Frequency : undefined}
                options={Frequency.map((item) => ({
                  label: item.value,
                  value: item.key,
                }))}
                allowClear
              />
            </div>
          </Grid>{" "}
        </Grid>
      </div>
    </>
  );
};

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    values = `${values.length} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

const BloomFire = ({
  state,
  categoriesId,
  selectedOptions,
  setSelectedOptions,
}) => {
  useEffect(() => {
    getBloomFireData();
  }, [state?.Catogarie]);

  // const [selectedOptions, setSelectedOptions] = useState([]);

  const AddItems = () => {
    let arr = [];
    state?.Categories &&
      state?.Categories?.map((item) => {
        arr.push({ value: item.name, label: item.name });
      });

    return arr;
  };

  const handleSelect = (data) => {
    // console.table("data",data)
    let val = AddItems().filter((item) => {
      return data.includes(item?.value)
    })
    // console.log("value",val)
    setSelectedOptions(val);
  };
  const arr = [];
  const res =
    state?.Categories?.length > 0 &&
    state?.Categories?.map((item) => {
      selectedOptions?.length > 0 &&
        selectedOptions?.map((val) => {
          if (item.name === val.label) {
            return arr.push(item.id);
          }
        });
    });

  useEffect(() => {
    categoriesId(arr);
  }, [arr.length]);
  const colourStyles = {
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        fontSize: "14px",
      };
    },
  };

  return (
    <div>
      <div className={styles.bloomFireCategoryContainer}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Categories<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span>:<span></span></span>
              {/* <VizParagraph type={5}>Categories*</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{
                display: "flex",
                justifyContent: "left",
                marginBottom: "14px",
                width: "350px",
              }}
            >
              <Select
                size="middle"
                mode="multiple"
                allowClear
                getPopupContainer={() => document.body}
                options={AddItems()}
                style={{ width: "100%", fontSize: "16px" }}
                placeholder="Select Categories"
                onChange={handleSelect}
                value={selectedOptions || []}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
                dropdownStyle={{ textAlign: "left" }}
                maxTagCount={0}
                maxTagPlaceholder={() =>
                  `${(selectedOptions || []).length} selected`
                }
              />

              {/* <Select
                // className={"multiselect1"}
                className={styles.bloomfireSelect}
                name="Categories"
                options={AddItems()}
                value={selectedOptions}
                onChange={handleSelect}
                isSearchable={true}
                components={{ ValueContainer }}
                placeholder="Select Categories"
                isMulti
                closeMenuOnSelect={false}
                width="200px"
                hideSelectedOptions={false}
                disabled={state?.loading ? true : false}
                styles={colourStyles}
                isClearable
              />  */}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

const IframModel = ({
  open,
  setOpen,
  image,
  width = "1620",
  height = "500",
}) => {
  const state = useSelector((state) => state.atomizer);
  const closePreview = () => {
    setOpen(!open);
  };
  return (
    <div
      className={`${styles.overlay}`}
      style={{ display: open ? "block" : "none" }}
      role="button"
      tabIndex={0}
      onClick={closePreview}
    >
      <div
        className={styles.overlaySub}
        role="button"
        tabIndex={0}
        justifyContent="center"
      >
        <iframe
          src={image}
          title="BloomFire"
          width={width}
          height={height}
          alignItems="center"
          allowfullscreen={true}
        ></iframe>
      </div>
    </div>
  );
};

const SeekerInput = ({ seekerEmail, setSeekerEmail }) => {
  const [inputval, setInputVal] = useState("");
  const [fetchUser, setFetchUser] = useState();
  const state = useSelector((state) => state?.atomizer);
  useEffect(() => {
    store.dispatch(handleResetSeeker(!state?.seekerEmail));
  }, []);
  const getUsers = (e) => {
    setInputVal(e.target.value);
    if (e.target.value.length > 3) {
      fetchUsers_CM_Atomizer(e.target.value, "seeker")
        .then((res) => {
          if (res === undefined) return;
          let filtered = res.data.data.users.filter(function (obj) {
            let found = false;
            seekerEmail.filter((obj2) => {
              if (obj2.userUuid === obj.userUuid) {
                found = true;
              }
            });
            if (found === false) {
              return obj;
            }
          });
          setFetchUser(filtered);
        })
        .catch((err) => { });
    }
  };
  const onClickRemoveUsers = (val) => {
    store.dispatch(handleSeekerInput(null));
    let filteredData = seekerEmail.filter((obj) => {
      if (obj.userUuid !== val) {
        return obj;
      }
    });
    setSeekerEmail(filteredData);
  };

  const onClickUsers = (val) => {
    store.dispatch(handleSeekerInput(val.email));
    if (seekerEmail?.length > 0) {
      seekerEmail.pop();
    }
    setSeekerEmail([...seekerEmail, val]);

    setFetchUser([]);
    setInputVal("");
  };

  return (
    <>
      <div className="form-control">
        {seekerEmail?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {seekerEmail.map((obj, ind) => {
              return (
                <p className={styles.selectedUserASG} key={ind}>
                  {`${obj.firstName} ${obj.lastName} <${obj.email}>`}

                  <span
                    className={styles.crossbuttonASK}
                    onClick={
                      !state?.loading
                        ? () => onClickRemoveUsers(obj.userUuid)
                        : null
                    }
                  >
                    x
                  </span>
                </p>
              );
            })}
          </div>
        ) : null}

        <input
          type="text"
          // className="form-control"
          value={inputval}
          placeholder="Enter Seekers name or email address"
          style={{
            border: "none ",
            fontSize: "14px",
            paddingLeft: "0px",
            width: "100%",
            // height: "35px",
          }}
          onChange={(e) => getUsers(e)}
          disabled={state?.loading ? true : false}
        />
      </div>

      {fetchUser && fetchUser?.length > 0 && inputval.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            backgroundColor: "#0000000008",
            width: "auto",
          }}
        >
          <span
            style={{
              border: "none ",
              fontSize: "14px",
            }}
          >
            {" "}
            {fetchUser?.length > 0 && inputval?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  backgroundColor: "#0000000008",
                  width: "auto",
                }}
              >
                <span
                  style={{
                    border: "none ",
                    fontSize: "14px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        padding: "7px",
                        border: "lightgrey solid 1px",
                        borderRadius: "5px",
                        fontSize: "12px",
                        textAlign: "left",
                      }}
                    >
                      {fetchUser &&
                        fetchUser?.map((user, ind) => {
                          return (
                            <div key={ind} className={styles.selectUser}>
                              <span
                                style={{
                                  textAlign: "left",
                                  cursor: "pointer",
                                }}
                                className={styles.watchListUserslist}
                                value={user.userUuid}
                                onClick={() => onClickUsers(user)}
                              >
                                {`${user.firstName} ${user.lastName} <${user.email}>`}
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </span>
              </div>
            )}
          </span>
        </div>
      )}
    </>
  );
};

const ExpertInput = ({ expertEmail, setExpertEmail }) => {
  const [inputval, setInputVal] = useState("");
  const [selected, setSelected] = useState([]);
  const [fetchUser, setFetchUser] = useState();

  const state = useSelector((state) => state?.atomizer);
  const getUsers = (e) => {
    setInputVal(e.target.value);
    if (e.target.value.length > 3) {
      fetchUsers_CM_Atomizer(e.target.value, "expert")
        .then((res) => {
          if (res === undefined) return;
          let filtered = res.data.data.users.filter(function (obj) {
            let found = false;
            expertEmail.filter((obj2) => {
              if (obj2.userUuid === obj.userUuid) {
                found = true;
              }
            });
            if (found === false) {
              return obj;
            }
          });
          setFetchUser(filtered);
        })
        .catch((err) => { });
    }
  };
  const onClickRemoveUsers = (val) => {
    store.dispatch(handleExpertInput(null));
    let filteredData = expertEmail.filter((obj) => {
      if (obj.userUuid !== val) {
        return obj;
      }
    });
    setExpertEmail(filteredData);
  };
  const onClickUsers = (val) => {
    store.dispatch(handleExpertInput(val.email));
    if (expertEmail?.length > 0) {
      expertEmail.pop();
    }
    setExpertEmail([...expertEmail, val]);
    setFetchUser([]);
    setInputVal("");
  };
  return (
    <>
      <div className="form-control">
        {expertEmail?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {expertEmail.map((obj, ind) => {
              return (
                <p className={styles.selectedUserASG} key={ind}>
                  {`${obj.firstName} ${obj.lastName} <${obj.email}>`}

                  <span
                    className={styles.crossbuttonASK}
                    onClick={
                      !state?.loading
                        ? () => onClickRemoveUsers(obj.userUuid)
                        : null
                    }
                  >
                    x
                  </span>
                </p>
              );
            })}
          </div>
        ) : null}

        <input
          type="text"
          // className="form-control"
          value={inputval}
          placeholder="Enter Experts name or email address"
          style={{
            border: "none ",
            fontSize: "14px",
            paddingLeft: "0px",
            width: "100%",
            // height: "35px",
          }}
          onChange={(e) => getUsers(e)}
          disabled={state?.loading ? true : false}
        />
      </div>

      {fetchUser && fetchUser?.length > 0 && inputval.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            backgroundColor: "#0000000008",
            width: "auto",
          }}
        >
          <span
            style={{
              border: "none ",
              fontSize: "14px",
            }}
          >
            {" "}
            {fetchUser?.length > 0 && inputval?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  backgroundColor: "#0000000008",
                  width: "auto",
                }}
              >
                <span
                  style={{
                    border: "none ",
                    fontSize: "14px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        padding: "7px",
                        border: "lightgrey solid 1px",
                        borderRadius: "5px",
                        fontSize: "12px",
                        textAlign: "left",
                      }}
                    >
                      {fetchUser &&
                        fetchUser?.map((user, ind) => {
                          return (
                            <div key={ind} className={styles.selectUser}>
                              <span
                                style={{
                                  textAlign: "left",
                                  cursor: "pointer",
                                }}
                                className={styles.watchListUserslist}
                                value={user.userUuid}
                                onClick={() => onClickUsers(user)}
                              >
                                {`${user.firstName} ${user.lastName} <${user.email}>`}
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </span>
              </div>
            )}
          </span>
        </div>
      )}
    </>
  );
};

const QAList = ({
  state,
  uploadFileData,
  handleFileUplaod,
  seekerEmail,
  setSeekerEmail,
  expertEmail,
  setExpertEmail,
}) => {
  const [open, setOpen] = useState(false);
  const handleIfram = () => {
    setOpen(!open);
  };

  return (
    <>
      <div className={styles.subContainer} style={{ marginTop: "10px" }}>
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "baseline",
          }}
        >
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Seeker<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span><span></span></span>
              {/* <VizParagraph type={5}>Seeker*</VizParagraph>&nbsp;: */}
            </div>
          </Grid>
          <Grid item xs={7}>
            <div className={styles.formInputs} style={{ width: "100%" }}></div>{" "}
            <SeekerInput
              seekerEmail={seekerEmail}
              setSeekerEmail={setSeekerEmail}
            />
          </Grid>
        </Grid>
      </div>

      <div className={styles.subContainer}>
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "baseline",
          }}
        >
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              {/* <VizParagraph type={5}>Expert*</VizParagraph>&nbsp;: */}
              <span style={textStyles}>Expert<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span><span></span></span>
            </div>
          </Grid>
          <Grid item xs={7}>
            <div className={styles.formInputs} style={{ width: "100%" }}>
              <ExpertInput
                expertEmail={expertEmail}
                setExpertEmail={setExpertEmail}
              />
            </div>
          </Grid>
        </Grid>
      </div>

      <div
        className={styles.subContainer}
        style={{ display: "flex", alignItems: "baseline" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              {/* <VizParagraph type={5}>xls File*</VizParagraph>&nbsp;: */}
              <span style={textStyles}>Xls File<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span><span></span></span>
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "baseline",
              }}
            >
              <UploadButton
                uploadFileData={uploadFileData}
                handleFileUplaod={handleFileUplaod}
                setSeekerEmail={setSeekerEmail}
                setExpertEmail={setExpertEmail}
              />
            </div>
          </Grid>{" "}
        </Grid>
      </div>

      <div className={styles.subContainer} style={{ marginBottom: "25px" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Click on image to view sample format   <span></span></span>

              {/* <VizParagraph type={5}>
             
              </VizParagraph> */}
              <span></span>
           
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{ display: "flex", justifyContent: "left" }}
            >
              <TapImageFile
                handleImage={handleIfram}
                imageProp={QA}
                open={open}
                setOpen={setOpen}
                state={state}
                width={703}
                height={125}
              />
            </div>
          </Grid>{" "}
        </Grid>
      </div>
    </>
  );
};

const ListOfBloomFireLink = () => {
  const [open, setOpen] = useState(false);

  const handleIfram = () => {
    setOpen(!open);
  };
  return (
    <>
      <div className={styles.subContainer} style={{ marginBottom: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <div className={styles.formLabels}>
              <span style={textStyles}>Click on image to view sample format<span>:</span></span>
              {/* <VizParagraph type={5}>
                Click on image to view sample format
              </VizParagraph> */}
            
            </div>
          </Grid>
          <Grid item xs={7}>
            <div
              className={styles.formInputs}
              style={{
                display: "flex",
                justifyContent: "left",
                marginRight: "10px",
              }}
            >
              <TapImageFile
                handleImage={handleIfram}
                imageProp={getchCsv}
                open={open}
                setOpen={setOpen}
                width={"100%"}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

// Driver code
function AtomizerForm() {
  const state = useSelector((state) => state.atomizer);
  const modalState = useSelector((state) => state.domain);
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // console.log(state);
  const {
    handlChangeJobId,
    selectType,
    uploadFile,
    handleChangeNameField,
    handleChangeLinkField,
    handleChangeUrl,
    handleChangeFrequency,
    handleImageCheck,
    handlePdfCheck,
    handleLoadingSpinner,
    handleChangeUrlValue,
    categoriesId,
    enableButtonAction,
    domainAtomizerUpdate
  } = bindActionCreators(Actions, dispatch);
  const [modal, setModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [seekerEmail, setSeekerEmail] = useState([]);
  const [expertEmail, setExpertEmail] = useState([]);
  const [showButton, setShowButton] = React.useState(true);
  useEffect(() => {
    setSeekerEmail([]);
    setExpertEmail([]);
  }, [state?.sourceType]);

  const handleChangeType = (e) => {
    // console.log(e.target.value)
    // console.log("evenet",e)
    selectType(e?.value);
  };

  const handleFileUplaod = (event) => {
    uploadFile(event.target.files[0]);
  };

  const handleMultipleFile = (event) => {
    uploadFile(event.target.files);
  };

  const handleChangeText = (e) => {
    handlChangeJobId(e.target.value);
  };

  const handleChangeName = (e) => {
    handleChangeNameField(e.target.value);
  };
  const handleChangeLink = (e) => {
    handleChangeLinkField(e.target.value);
  };

  const handleChangeImage = (e) => {
    handleImageCheck(!state?.isIncludeImageChecked);
  };

  const handleChangeUrlDepth = (value) => {


    handleChangeUrl(value);
  };
  const handleChangeFrequencyValue = (value, option) => {
    // console.log("Selected Value:", value);        // item.key
    // console.log("Selected Label:", option.label); // item.value
    handleChangeFrequency(value); // or pass both if needed
  };
  // This function performs the operation of the submit
  const handleOnSubmit = () => {
    handleLoadingSpinner(!state?.loading);

    switch (state?.sourceType) {
      case "PDF":
      case "PDF Native":
      case "Image":
      case "Video":
        return postPdfAtomizer(state);
      case "Scrape URL":
        return postScrapUrl(state);
      case "List of PDF URL Links (CSV)":
        return listOfPdfUrl(state);
      case "Q&A List (CSV)":
        return QAPostForm(state, setSeekerEmail, setExpertEmail);
      case "PDF URL Link":
        return pdfUrlData(state);
      case "List of Bloomfire Links (CSV)":
        return Bloomfire(state);
      case "Multiple Files":
        return handleMultipleFiles(state);
      case "Bloomfire Category":
        return postBlommfireCaegory(state, setSelectedOptions);
      default:
        break;
    }
  };

  const handleChangePdfCheck = () => {
    handlePdfCheck(!state?.isIncludePdfChecked);
  };

  const handleUrl = (e) => {
    handleChangeUrlValue(e.target.value);
  };

  // This function renders the component when we change the source type

  const renderSection = () => {
    switch (state.sourceType) {
      case "PDF":
      case "PDF Native":
      case "Image":
      case "Video":
      case "List of PDF URL Links (CSV)":
      case "Multiple Files":
        return (
          <>
            <JobSection
              JobId={state?.jobId}
              handleChangeText={handleChangeText}
            />
            {domainSection(state.domainIds, domainAtomizerUpdate, userState)}
          </>
        );
      case "Scrape URL":


        return (
          <ScrapUrl
            name={state.Name}
            handleChangeName={handleChangeName}
            handleChangeLink={handleChangeLink}
            handleImageCheck={handleChangeImage}
            handlePdfCheck={handleChangePdfCheck}
            handleChangeUrlDepth={handleChangeUrlDepth}
            handleChangeFrequencyValue={handleChangeFrequencyValue}
            state={state}
          />
        );
      case "PDF URL Link":
        return (
          <>
            <PdfLinkUrl
              state={state}
              handleChangeText={handleChangeText}
              UrlValue={state?.UrlValue}
              handleChangeName={handleUrl}
            />
          </>
        );
      case "Bloomfire Category":
        return (
          <BloomFire
            state={state}
            bloomFireOption={state.bloomFireOption}
            categoriesId={categoriesId}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
          />
        );
      case "Q&A List (CSV)":
        return (
          <QAList
            state={state}
            modal={modal}
            setModal={setModal}
            uploadFileData={state.uploadFileData}
            handleFileUplaod={handleFileUplaod}
            seekerEmail={seekerEmail}
            setSeekerEmail={setSeekerEmail}
            expertEmail={expertEmail}
            setExpertEmail={setExpertEmail}
          // onClickRemoveUsers={onClickRemoveUsers}
          />
        );
      case "List of Bloomfire Links (CSV)":
        return <ListOfBloomFireLink />;
      default:
        return undefined;
    }
  };

  // This function renders different labels of the upload file button

  const renderFileLabel = () => {
    switch (state.sourceType) {
      case "PDF":
        return "PDF File";
      case "PDF Native":
        return "PDF File";
      case "Image":
        return "Image";
      case "Video":
        return "Video File";
      case "List of PDF URL Links (CSV)":
        return "CSV File";
      case "Multiple Files":
        return "Multiple Files";
      case "List of Bloomfire Links (CSV)":
        return "CSV File";

      default:
        break;
    }
  };
  // this function renders the upload file button
  const renderChooseFile = () => {
    switch (state.sourceType) {
      case "PDF":
      case "Image":
      case "Video":
      case "PDF Native":
      case "List of PDF URL Links (CSV)":
        return (
          <UploadButton
            uploadFileData={state.uploadFileData}
            handleFileUplaod={handleFileUplaod}
          />
        );
      case "Multiple Files":
      case "List of Bloomfire Links (CSV)":
        return (
          <UploadButton
            uploadFileData={state?.uploadFileData}
            handleFileUplaod={handleMultipleFile}
          />
        );

      default:
        break;
    }
  };

  return (
    <>
      <div style={container}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "30px",
          }}
        >
          <span style={textStylesHeader}>
            Knowledge Atomizer
          </span>

        </div>
        <div className={styles.subContainer}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <div className={styles.formLabels}>
                <span style={textStyles}>Source Type<span></span></span>
                {/* <VizParagraph type={5}>Source Type</VizParagraph>&nbsp;: */}
              </div>
            </Grid>
            <Grid item xs={7}>
              <div>
                <HtmlSelect
                  selectTypes={selectTypes}
                  selectState={state.sourceType}
                  handleChangeType={handleChangeType}
                  loading={state?.loading}
                />
              </div>
            </Grid>
          </Grid>
        </div>
        {state?.sourceType === "PDF" ||
          state?.sourceType === "PDF Native" ||
          state?.sourceType === "Video" ||
          state?.sourceType === "Image" ||
          state?.sourceType === "List of PDF URL Links (CSV)" ||
          state?.sourceType === "List of Bloomfire Links (CSV)" ||
          state?.sourceType === "Multiple Files" ? (
          <div className={styles.subContainer}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <div className={styles.formLabels}>
                  <span style={textStyles}>{renderFileLabel()}<span className="iconsRed" style={{ verticalAlign: "super", fontSize: "0.8em" }}>*</span></span>
                  {/* <VizParagraph type={5}>{renderFileLabel()}</VizParagraph> */}
                  {/* &nbsp;: */}
                </div>
              </Grid>
              <Grid item xs={7}>
                <div
                  className={styles.formInputs}
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                  }}
                >
                  {renderChooseFile()}
                </div>
              </Grid>
            </Grid>
          </div>
        ) : null}


        <div>{renderSection()}</div>
        {/* <div>}</div> */}


        <div className={styles.subContainer}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <div className={styles.formLabels} style={{ zIndex: 2 }}>
                {/* {state?.loading ? (
                  <img src={Loader} alt="loader on submit" />
                ) : null} */}
              </div>
            </Grid>
            <Grid item xs={7}>
              <div
                className={styles.formInputs}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "0px",
                  width: "100%",
                }}
              >
                <SubmitButton
                  handleOnSubmit={handleOnSubmit}
                  showButton={showButton}
                  setShowButton={setShowButton}
                />
              </div>
            </Grid>
          </Grid>
          {modalState?.modalState &&
            modalState.modalName === "atomizerResponse" ? (
            <AtomizerModal open={state.showModal} />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default AtomizerForm;
